import { Injectable } from "@angular/core";
import { CacheFactory, CacheStore, StorageMode } from "@obg/ngx.global";
import { Observable } from "rxjs";

const CACHE_STORE_KEY = "core.snackbar";
const CACHE_KEY_POSTFIX = "-snackbar-do-not-show-again";

@Injectable()
export class SnackBarCacheService {
	private cache: CacheStore;

	constructor(cacheFactory: CacheFactory) {
		this.cache = cacheFactory.get(CACHE_STORE_KEY, {
			storageMode: StorageMode.LocalStorage,
			maxAge: Number.MAX_VALUE,
		});
	}

	getSnackbarDoNotShowAgain$(id: string): Observable<boolean | null> {
		return this.cache.getItemAsObservable<boolean>(`${id}${CACHE_KEY_POSTFIX}`);
	}

	setSnackbarDoNotShowAgain(id: string) {
		this.cache.setItem(`${id}${CACHE_KEY_POSTFIX}`, true);
	}

	changeSnackbarDoNotShowAgainExpiration(id: string, maxAge?: number) {
		this.cache.getItem(`${id}${CACHE_KEY_POSTFIX}`).then((item) => {
			if (item) {
				this.cache.setItem(`${id}${CACHE_KEY_POSTFIX}`, item, { maxAge });
			}
		});
	}

	removeSnackbarDoNotShowAgain(id: string) {
		this.cache.removeItem(`${id}${CACHE_KEY_POSTFIX}`);
	}
}
